import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography, Box, TextField, Button, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress } from '@mui/material';
import { toast } from 'react-toastify';
import PageHeader from '../../components/PageHeader';
import { getCurrencies, updateCurrencies } from '../../api/endpoints/settings';

const DEFAULT_CURRENCIES = [
  { code: 'INR', symbol: '₹', name: 'Indian Rupee', rate: 1 },
  { code: 'USD', symbol: '$', name: 'US Dollar', rate: 0.012 },
  { code: 'EUR', symbol: '€', name: 'Euro', rate: 0.011 },
  { code: 'GBP', symbol: '£', name: 'British Pound', rate: 0.0095 },
  { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham', rate: 0.044 },
];

const CurrencySettings = () => {
  const [currencies, setCurrencies] = useState(DEFAULT_CURRENCIES);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCurrencies();
  }, []);

  const fetchCurrencies = async () => {
    try {
      setLoading(true);
      const res = await getCurrencies();
      const data = res.data.data || [];
      if (Array.isArray(data) && data.length) {
        setCurrencies(data);
      }
    } catch {
      // use defaults
    } finally {
      setLoading(false);
    }
  };

  const handleRateChange = (code, value) => {
    setCurrencies((prev) => prev.map((c) => c.code === code ? { ...c, rate: parseFloat(value) || 0 } : c));
  };

  const handleSave = async () => {
    try {
      await updateCurrencies(currencies);
      toast.success('Currency settings saved');
    } catch {
      toast.error('Failed to save');
    }
  };

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress /></Box>;

  return (
    <Box>
      <PageHeader title="Currency Settings" subtitle="Manage supported currencies and exchange rates" />
      <Card>
        <CardContent>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Code</TableCell>
                  <TableCell>Symbol</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell align="right">Rate (1 INR = ?)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currencies.map((c) => (
                  <TableRow key={c.code}>
                    <TableCell><Typography fontWeight={600}>{c.code}</Typography></TableCell>
                    <TableCell><Typography variant="h6">{c.symbol}</Typography></TableCell>
                    <TableCell>{c.name}</TableCell>
                    <TableCell align="right">
                      <TextField size="small" type="number" value={c.rate} onChange={(e) => handleRateChange(c.code, e.target.value)}
                        inputProps={{ step: 0.001, min: 0 }} sx={{ width: 120 }} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button variant="contained" onClick={handleSave}>Save Currency Settings</Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CurrencySettings;
